<template>
  <div class="bg-blackly flex flex-col justify-end relative">
    <CraftAsset
      v-if="image[0]"
      class="h-full object-cover hidden md:block bg-white"
      :ratio="16 / 9"
      crop="fill"
      sizes="30vw sm:30vw md:30vw lg:30vw xl:30vw 2xl:405px"
      :asset="image[0]"
      :alt="alt"
      autoplay
      muted
    />
    <CraftAsset
      v-if="image[0]"
      class="block object-cover h-1/2 md:hidden"
      :ratio="3 / 2"
      crop="fill"
      sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
      :asset="image[0]"
      :alt="alt"
      autoplay
      muted
    />
    <div class="relative md:absolute h-full md:h-auto w-full">
      <div class="box md:m-6 h-full flex flex-col justify-center">
        <BarText v-if="heading" tag="h2" class="mb-10" :text="heading" data-test-id="header" />
        <CtaArrow v-if="cta[0] && cta[0].text" v-bind="cta[0]" class="cta-arrow font-medium" />
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import CtaArrow from '@/components/common/CtaArrow';
import CraftAsset from '@/components/common/CraftAsset';
import BarText from '@/components/BarText';

export const GridBlocksOneByOneImageCtaFragment = gql`
  fragment GridBlocksOneByOneImageCtaFragment on oneByOneImageCta_Entry {
    position
    typeHandle
    image {
      ...CraftAssetFragment
    }
    alt
    heading
    cta {
      ...LinkFragment
    }
  }
`;
export default defineNuxtComponent({
  name: 'OneByOneImageCta',
  components: { CtaArrow, CraftAsset, BarText },
  cols: 1,
  rows: 1,
  props: {
    position: {
      type: Number,
      default: null,
    },
    image: {
      type: Array,
      default: () => [],
    },
    alt: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    cta: {
      type: Array,
      default: () => {},
    },
  },
});
</script>
